"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var storefront_service_1 = require("../../services/storefront.service");
var cross_sell_products_template_1 = require("../../templates/cross-sell-products.template");
var CrossSellProducts = /** @class */ (function () {
    function CrossSellProducts(cart) {
        this.storefrontService = new storefront_service_1["default"]();
        this.selectors = {
            body: 'body',
            dataModuleCartFreeGifts: '[data-module-cart-free-gifts]',
            crossSellContainer: '.js-cross-sell-container',
            crossSellCloseBtn: '.js-cross-sell-close',
        };
        this.cart = cart;
    }
    CrossSellProducts.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, response, items, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.cart.items.length) {
                            return [2 /*return*/, []];
                        }
                        queryParams = this.getQueryParams();
                        return [4 /*yield*/, this.storefrontService.get("/cross-sell-products-data?" + queryParams)];
                    case 1:
                        response = _a.sent();
                        if (!response) {
                            return [2 /*return*/, []];
                        }
                        if (!response.success) {
                            return [2 /*return*/, []];
                        }
                        items = response.data;
                        if (!items.length) {
                            return [2 /*return*/, []];
                        }
                        items.sort(function (a, b) { return (a.priority > b.priority) ? -1 : 1; });
                        return [2 /*return*/, [items[0]]];
                    case 2:
                        err_1 = _a.sent();
                        console.log(err_1, 'Can not fetch cross sell products data');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CrossSellProducts.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var products, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.bindEvents();
                        return [4 /*yield*/, this.get()];
                    case 1:
                        products = _a.sent();
                        this.appendProducts(products);
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        console.log(err_2, 'Can not fetch cross sell products data');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ;
    CrossSellProducts.prototype.bindEvents = function () {
        var _this = this;
        var $body = $(this.selectors.body);
        $body.on('click', this.selectors.crossSellCloseBtn, function (e) {
            $(_this.selectors.crossSellContainer).hide();
        });
    };
    CrossSellProducts.prototype.getQueryParams = function () {
        var ids = this.cart.items.map(function (item) {
            return item.product_id;
        });
        var idsQueryParam = '';
        for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
            var id = ids_1[_i];
            idsQueryParam += "shopifyProductIds[]=" + id + "&";
        }
        return idsQueryParam;
    };
    CrossSellProducts.prototype.appendProducts = function (data) {
        var _this = this;
        data = data.filter(function (item) {
            var isItemInCart = false;
            for (var _i = 0, _a = _this.cart.items; _i < _a.length; _i++) {
                var cartItem = _a[_i];
                if (item.handle === cartItem.handle) {
                    isItemInCart = true;
                    break;
                }
            }
            return !isItemInCart;
        });
        var html = cross_sell_products_template_1["default"](data);
        $(this.selectors.crossSellContainer).html(html);
    };
    return CrossSellProducts;
}());
exports["default"] = CrossSellProducts;
